import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const BoxOfferPlanIcon: React.FC<IconSvgProps> = (props) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.388672"
      y="11.0713"
      width="19.1859"
      height="13.1837"
      rx="1.11447"
      transform="rotate(-30 0.388672 11.0713)"
      stroke={props.color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M8.14063 12.7121L8.14062 14.8961M12.4133 12.7119V14.896M8.1599 13.8039H11.9702"
      stroke={props.color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const BoxOfferNoOfferPlanIcon: React.FC<IconSvgProps> = (props) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.54058 20.8025L1.4806 13.9956C0.631877 12.5726 1.09739 10.731 2.52036 9.88232L7.69015 6.79881L8.71465 8.51649L3.54486 11.6C3.07054 11.8829 2.91536 12.4968 3.19827 12.9711L7.25825 19.778C7.54127 20.252 8.15515 20.4074 8.62934 20.1246L13.7991 17.0411L14.8236 18.7588L9.65384 21.8423C8.23101 22.6909 6.38941 22.2252 5.54058 20.8025Z"
      fill={props.color}
    />
    <path
      d="M4.97807 4.64521C4.69516 4.17089 4.85033 3.55703 5.32466 3.27413C5.79898 2.99122 6.41284 3.14639 6.69574 3.62071L16.8446 20.6362C17.1275 21.1105 16.9723 21.7244 16.498 22.0073C16.0237 22.2902 15.4098 22.135 15.1269 21.6607L4.97807 4.64521Z"
      fill={props.color}
    />
    <path
      d="M20.7494 12.8958L15.6649 4.37117L11.193 7.03847L10.1685 5.3208L14.6404 2.6535C15.5891 2.08776 16.8168 2.39806 17.3826 3.34667L22.4671 11.8713C23.0326 12.8199 22.7224 14.0477 21.7739 14.6135L17.3019 17.2808L16.2774 15.5631L20.7494 12.8958Z"
      fill={props.color}
    />
  </svg>
)
